import { render, staticRenderFns } from "./ProjectEditPage.vue?vue&type=template&id=3b8e502d&"
import script from "./ProjectEditPage.vue?vue&type=script&lang=ts&"
export * from "./ProjectEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports